<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form label-width="70px" class="details-line-height" style="padding:20px 30px 10px 30px">
        <!------------------------ 普通 ------------------------>
        <div v-if="invoice===2">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="退票编号：">{{invoicingParams.subNumber}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="发票类型："
                v-if="type==='orderContractInvoiceSub'"
              >{{invoicingParams.invoiceType}}</el-form-item>
              <el-form-item label="发票类型：" v-else>{{invoicingParams.subType===2?'普通发票':'红字发票'}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退票类型：">{{$route.query.type}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="type==='orderContractInvoiceSub'">
            <el-col :span="8">
              <el-form-item label="公司名称：">
                <div>{{invoicingParams.suName||invoicingParams.cusName}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="税号：">{{invoicingParams.taxNumber}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="银行账号：">{{invoicingParams.bankOpen}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票地址：">{{invoicingParams.invoiceAddress}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开户行：">{{invoicingParams.bankOpen}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间：">{{invoicingParams.createDate|dateFilter}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退票原因：">{{invoicingParams.mark}}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-else>
            <el-col :span="8">
              <el-form-item label="公司名称：">
                <div
                  class="approval"
                  @click="supplierDetail"
                >{{invoicingParams.suName||invoicingParams.cusName}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="退票原因：">{{invoicingParams.mark}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间：">{{invoicingParams.createDate|dateFilter}}</el-form-item>
            </el-col>
          </el-row>
        </div>
        <!------------------------ 红字 ------------------------>
        <el-row :gutter="20" v-if="invoice===1">
          <el-col :span="8">
            <el-form-item label="退票编号：">{{invoicingParams.subNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="发票类型："
              v-if="type==='orderContractInvoiceSub'"
            >{{invoicingParams.invoiceType}}</el-form-item>
            <el-form-item label="发票类型：" v-else>{{invoicingParams.subType===2?'普通发票':'红字发票'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票类型：">{{$route.query.type}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司名称：">
              <div v-if='invoicingParams.state ===1 || invoicingParams.state === 4'>
              {{invoicingParams.suName||invoicingParams.cusName}}
              </div>
              <div
                class="approval"
                v-if="$route.query.type==='开票退票' && invoicingParams.state !==1 && invoicingParams.state !==4"
                @click='customDetail'
              >{{invoicingParams.suName||invoicingParams.cusName}}</div>
              <div
                class="approval"
                  v-if="$route.query.type==='收票退票'&& invoicingParams.state !==1 && invoicingParams.state !==4"
                @click="supplierDetail"
              >{{invoicingParams.suName||invoicingParams.cusName}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联发票编号：" label-width="98px">{{invoicingParams.invoiceNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{invoicingParams.createDate|dateFilter}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票原因：">{{invoicingParams.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!------------------------------ 关联开票信息 -------------------------------->
    <div class="item-box-content details-line-height" v-if="false">
      <div class="title-font-style">
        <span>关联开票信息</span>
      </div>
      <el-form
        label-position="left"
        :model="item"
        v-for="(item, index) in VoList"
        :key="index"
        style="padding:20px 20px 0 30px;"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="原开票编号：">{{ item.invoiceNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同编号：">{{ item.contractCode }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户合同编号：" label-width="100px">{{ item.customerContractCode||'--' }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{ item.createDate | dateFilterL }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开票备注：">{{ item.invoiceMark||'--' }}</el-form-item>
          </el-col>
        </el-row>
        <div class="solid"></div>
      </el-form>
    </div>
    <div class="item-box-content" style="padding-bottom:0">
      <div class="title-font-style">
        <span>票据信息</span>
      </div>
      <el-form label-width="70px" class="details-line-height" style="padding:20px 30px 10px 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="退票状态："
            >{{invoicingParams.state===6?'待收票':invoicingParams.state===5?'拒绝退票':invoicingParams.state===4?'已退票':invoicingParams.state===3?'审核不通过':'退票审核'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票金额：">{{invoicingParams.amount|priceFilter}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="发票税额："
            >{{(invoicingParams.taxAmounts||invoicingParams.taxAmount)|priceFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="state===3">
          <el-col :span="8">
            <el-form-item
              label="发票编号："
              v-if="invoicingParams.state===4"
            >{{$route.query.type === '开票退票' ? invoicingParams.invoiceCode : invoicingParams.invoiceNumber }}</el-form-item>
            <el-form-item label-width="84px" label="不通过原因：" v-else>{{invoicingParams.mark}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="处理人："
            >{{invoicingParams.staffCnName||invoicingParams.processUser||'--'}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退票时间：">{{invoicingParams.processDate|dateFilterL}}</el-form-item>
          </el-col>
        </el-row>
        <div v-else>
          <el-form-item v-if="state===1" label="审核结果：">
            <el-radio-group v-model="radio">
              <el-radio label="2">通过</el-radio>
              <el-radio label="3">{{invoice===1?'退回':'拒绝'}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-else>
            <el-form-item label="处理方案：" v-if="invoice===2">
              <el-radio-group v-model="radio">
                <el-radio label="4">已退票</el-radio>
                <el-radio label="5">拒绝退票</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="处理方案：" v-else>
              <el-radio-group v-model="radio" v-if="type==='orderContractInvoiceSub'">
                <el-radio label="4">已收票</el-radio>
                <el-radio label="5">拒绝退票</el-radio>
              </el-radio-group>
              <div v-else>
                <span v-if="invoicingParams.invoiceRedCode">收到红字发票后，录入发票编号</span>
                <el-radio-group v-model="radio" v-else>
                  <el-radio label="4">开红字信息表</el-radio>
                  <el-radio label="5">拒绝退票</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </div>
          <div v-if="radio==='4'&&invoice===1">
            <el-form-item
              class="item-input"
              v-if="!invoicingParams.invoiceRedCode&&type!=='orderContractInvoiceSub'"
              label="红字信息表编号："
              :rules="filter_rules({required:true})"
              label-width="124px"
            >
              <el-input v-model="invoiceRedCode" style="width:280px" placeholder="请录入红字信息表编号"></el-input>
            </el-form-item>
            <div v-else>
              <el-form-item
                class="item-input"
                label="红字信息表编号："
                :rules="filter_rules({required:true})"
                label-width="124px"
              >
                <el-input v-model="invoiceRedCode" style="width:280px" placeholder="请录入红字信息表编号"></el-input>
              </el-form-item>
              <el-form-item
                class="item-input"
                label="红字发票编号："
                :rules="filter_rules({required:true})"
                label-width="124px"
              >
                <el-input v-model="invoiceRedNumber" style="width:280px" placeholder="请录入红字发票编号"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-row v-if="radio==='3'">
            <el-col :span="20">
              <el-form-item label="备注：" :rules="filter_rules({required:true})">
                <el-input v-model="mark" type="textarea" :rows="3" placeholder="选择退回，请填写拒绝原因"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="radio==='5'">
            <el-col :span="20">
              <el-form-item label-width="85px" label="被拒原因：" :rules="filter_rules({required:true})">
                <el-input v-model="mark" type="textarea" :rows="3" placeholder="请填写拒绝退票原因！"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-button type="primary" letter-spacing @click="submitBtn">提交</el-button>
        </div>
      </el-form>
    </div>
    <div class="item-box-content" style="padding-bottom:0">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <el-form
        label-width="70px"
        :class="invoicingParams.state === 4&&invoice===2?'':'details-line-height'"
        style="padding:20px 30px 10px 30px"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收票人：">{{invoicingParams.receivePeople}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{invoicingParams.receivePhone}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收票地址：">{{invoicingParams.receiveAddress}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="invoicingParams.state === 4&&invoice===2">
          <el-col :span="8">
            <el-form-item label="物流公司：">
              <el-input v-model="invoicingParams.logsticCompany" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="padding:0px;">
            <el-col :span="18">
              <el-form-item label="物流单号：">
                <el-input v-model="invoicingParams.logsticNumber" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="onStore">保存</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <el-row style="margin-bottom:20px">
        <el-col :span="12" class="title-font-style">
          <span>产品详情</span>
        </el-col>
        <el-col :span="12" style="text-align: right" v-if="state===2">
          <el-button @click="onExport">导出清单</el-button>
        </el-col>
      </el-row>
      <!--------------------------- 销售列表(开票) --------------------------->
      <el-table
        v-if="type==='orderContractInvoiceSub'"
        border
        ref="tableRef"
        :data="list"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column label="销售合同编号" show-overflow-tooltip width="125">
          <template slot-scope="scope">
            <span class="approval" @click="toContract(scope.row)">{{ scope.row.contractCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户合同编号"
          show-overflow-tooltip
          prop="customerContractCode"
          width="110"
        ></el-table-column>
        <el-table-column label="产品名称" show-overflow-tooltip prop="proName"></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="approval" @click="onProductDetail(scope.row)">{{ scope.row.proType }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订货号" show-overflow-tooltip prop="orderNumber"></el-table-column>
        <el-table-column label="单位" prop="cbUnit"></el-table-column>
        <el-table-column label="数量" prop="count"></el-table-column>
        <el-table-column label="销售单价">
          <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{scope.row.cbRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="总报价">
          <template slot-scope="scope">{{scope.row.cbTotal|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="税率">
          <template slot-scope="scope">{{scope.row.taxRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="税额">
          <template slot-scope="scope">{{scope.row.taxAmount|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="实际供货单价" width="110px">
          <template slot-scope="scope">{{scope.row.cbUnitPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="实际供货总价" width="110px">
          <template slot-scope="scope">{{scope.row.cbUnitTotal|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
      <!--------------------------- 采购列表(收票) --------------------------->
      <el-table
        v-else
        border
        ref="tableRef"
        :data="list"
        max-height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column label="采购合同编号" show-overflow-tooltip width="150">
          <template slot-scope="scope">
            <span class="approval" @click="toSupplier(scope.row)">{{ scope.row.pcbNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="供应商合同编号"
          show-overflow-tooltip
          prop="supplierContractNumber"
          width="120"
        ></el-table-column>
        <el-table-column label="产品名称" show-overflow-tooltip prop="proName"></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="approval" @click="onProductDetail(scope.row)">{{ scope.row.proModel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订货号" show-overflow-tooltip prop="proOrdernum"></el-table-column>
        <el-table-column label="单位" prop="proUnit"></el-table-column>
        <el-table-column label="数量" prop="count"></el-table-column>
        <el-table-column label="实付单价" width="100px">
          <template slot-scope="scope">{{scope.row.purchasePrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="实付总额" width="100px">
          <template slot-scope="scope">{{scope.row.actualTotal|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="税率" width="100px">
          <template slot-scope="scope">{{scope.row.taxRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="税额" width="100px">
          <template slot-scope="scope">{{scope.row.taxAmount|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
    </div>
    <!------------------------------ 工单日志 -------------------------------->
    <operation-log-and-flow flowLabel="退票流程" :typesel="typesel" :id="id"></operation-log-and-flow>
    <open-or-close
      @onUpdataState="onUpdataState"
      :content="content"
      title="提交确认"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import {
  financeCreditCoeDerive,
  financeRefundTicketCoeDerive,
  queryByFinanceid,
  updateStateByFprsIdwrit,
  updateStateBySub,
  updateStateByRed,
  updateLogisticsById
} from '@/api/fiance/fianceManage'
import OpenOrClose from '@/components/OpenOrClose/index'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow'
import { downLoadFileBlob } from '@/util/tool'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'operation-log-and-flow': operationLogAndFlow
  },
  data() {
    return {
      typesel: '', // 工单日志
      invoicingParams: {}, // 开票信息
      list: [], // 产品清单
      VoList: [], // 关联开票
      id: 0,
      radio: '',
      type: '', // 开票 / 收票
      invoice: 0, // 1 红字 2 退票
      state: 0, // 1 审核 / 2 处理  / 3 详情
      content: '',
      mark: '',
      invoiceRedCode: '', // 红字信息表编号
      invoiceRedNumber: '' // 发票编号(红字发票编号)
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.invoice = +this.$route.query.invoice
    this.state = +this.$route.query.state
    this.radio = this.state === 1 ? '2' : '4'
    this.typesel =
      this.$route.query.type === '开票退票'
        ? 'OrderContractInvoiceSubService'
        : 'PurchaseContractInvoiceSubService'
    this.type =
      this.$route.query.type === '开票退票'
        ? 'orderContractInvoiceSub'
        : 'purchaseContractInvoiceSub'
    this.init()
  },
  methods: {
    supplierDetail() {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: this.invoicingParams.suId }
      })
    },
    customDetail() {
      this.$router.push({
        path: '/crm/customer/details',
        query: { id: this.invoicingParams.cusId }
      })
    },
    onExport() {
      const obj = {
        oisId: this.id,
        type: this.type
      }
      if (this.invoice === 1) {
        obj.financeCreditUrl = this.$store.state.financeCreditUrl
        financeCreditCoeDerive(obj).then(res => {
          downLoadFileBlob(this, res)
        })
      } else {
        obj.financeRefundTicketUrl = this.$store.state.financeRefundTicketUrl
        financeRefundTicketCoeDerive(obj).then(res => {
          downLoadFileBlob(this, res)
        })
      }
    },
    init() {
      queryByFinanceid(this.id, this.type).then(res => {
        if (res.data.code === 200) {
          if (res.data.obj.orderContractInvoiceSubTypeVo) {
            // 开票
            this.invoicingParams = res.data.obj.orderContractInvoiceSubTypeVo
            this.list =
              res.data.obj.orderContractInvoiceSubTypeVo.orderContractInvoiceSubContentListVos
            this.VoList = res.data.obj.orderContractInvoiceSubTypeVo.orderContractInvoiceMergeVoList
          } else {
            // 收票
            this.invoicingParams =
              res.data.obj.purchaseContractInvoiceSubAllVo.purchaseContractInvoiceSubDetailVo
            this.list =
              res.data.obj.purchaseContractInvoiceSubAllVo.purchaseContractInvoiceSubDetailProductVoList
          }
          this.invoiceRedCode = this.invoicingParams.invoiceRedCode || ''
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onStore() {
      if (this.invoicingParams.logsticCompany && this.invoicingParams.logsticNumber) {
        const type = this.$route.query.type === '开票退票' ? 1 : 2
        updateLogisticsById(this.invoicingParams, type).then(res => {
          if (res.data.code === 200) {
            this.$message.success('物流信息修改成功！')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请填写物流信息！')
      }
    },
    // 提交
    submitBtn() {
      if (this.radio === '3' && !this.mark) {
        this.$message.error('必填项不能为空，请检查！')
        return
      }
      if (this.radio === '5' && !this.mark) {
        this.$message.error('必填项不能为空，请检查！')
        return
      }
      if (this.invoice === 1 && this.radio === '4') {
        if (!this.invoicingParams.invoiceRedCode && !this.invoiceRedCode) {
          this.$message.error('必填项不能为空，请检查！')
          return
        }
        if (this.invoicingParams.invoiceRedCode || this.type === 'orderContractInvoiceSub') {
          if (!this.invoiceRedCode || !this.invoiceRedNumber) {
            this.$message.error('必填项不能为空，请检查！')
            return
          }
        }
      }
      if (this.state === 1) {
        this.content = '确定提交审核结果？<br/>审核通过进入待处理退票申请列表'
      } else {
        this.content = '确定提交处理结果？'
      }
      this.$refs.openOrCloseRefs.onInitial()
    },
    // 确认
    onUpdataState() {
      const obj = {
        id: this.id,
        mark: this.mark,
        type: this.type,
        megerCode: this.invoicingParams.megerCode
      }
      if (this.state === 1) {
        // 审核
        const str =
          this.invoice === 1 ? 'updateStateByOcisIdReviewHz' : 'updateStateByOcisIdReviewPt'
        updateStateByFprsIdwrit([obj], { state: this.radio }, str).then(res => {
          if (res.data.code === 200) {
            this.$message.success('提交成功！')
            const src =
              this.invoice === 2 ? 'commonReturnTicketApplyList' : 'redReturnTicketApplyList'
            this.$router.push({
              name: src,
              query: { actName: 2 }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        // 处理
        if (this.invoice === 2) {
          updateStateBySub(obj, this.radio).then(res => {
            if (res.data.code === 200) {
              this.$message.success('提交成功！')
              this.$router.push({
                name: 'commonReturnTicketApplyList',
                query: { actName: 4 }
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          obj.invoiceRedCode = this.invoiceRedCode
          obj.invoiceRedNumber = this.invoiceRedNumber
          if (this.radio === '5') {
            obj.state = 5
          } else {
            obj.state =
              this.type === 'orderContractInvoiceSub' ? 2 : this.invoicingParams.state === 6 ? 2 : 1
            // if (this.type === 'orderContractInvoiceSub') {
            //   obj.state = 2
            // } else {
            //   obj.state = this.invoicingParams.invoiceRedCode ? 2 : 1
            // }
          }
          updateStateByRed(obj).then(res => {
            if (res.data.code === 200) {
              this.$message.success('提交成功！')
              const name = this.invoicingParams.state === 6 ? 4 : 3
              this.$router.push({
                name: 'redReturnTicketApplyList',
                query: { actName: name }
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      }
    },
    toSupplier(row) {
      this.$router.push({
        name: 'contractDetails',
        query: { type: '履行中', pcbId: row.covenantId }
      })
    },
    toContract(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.covenantId, cusId: row.cusId }
      })
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
